// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
// import "lib-flexible/flexible";
import $ from "jquery";
import "bootstrap3/dist/css/bootstrap.min.css";
import "bootstrap3/dist/js/bootstrap.min";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
//import { myRequest, logindex } from "./util/api.js";
import axios from "axios";
import common from "@/components/common";
import MetaInfo from "vue-meta-info";
import { HappyScroll } from "vue-happy-scroll";
import store from "./store";
import Mint from "mint-ui";
//自定义组件名
Vue.component("happy-scroll", HappyScroll);
// 引入css
import "vue-happy-scroll/docs/happy-scroll.css";

import * as filters from "./util/filter.js";

Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));
//Vue.prototype.$myRuquest = myRequest;
//Vue.prototype.$logindex = logindex;
// import "./util/rem";
Vue.prototype.$axios = axios;
Vue.prototype.common = common;
axios.defaults.baseURL = "/api"; //关键代码
//Vue.prototype.qs = qs;

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(MetaInfo);
Vue.use(Mint);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  mounted() {},
  components: { App },
  template: "<App/>"
});

// 路由变化跳转页面回到顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});



// WEBPACK FOOTER //
// ./src/main.js